<h1 class="colorSearch" mat-dialog-title>
    <span *ngIf="this.dialogTitle == 'DATACHIRACCDATI'">MODIFICA DATA CHIUSURA RACCOLTA DATI</span>
    <span *ngIf="this.dialogTitle == 'APERACCDATI'">MODIFICA STATO RACCOLTA DATI</span>
    <span *ngIf="this.dialogTitle == 'DATACHICORRDATI'">MODIFICA DATA CHIUSURA CORREZIONE DATI</span>
    <span *ngIf="this.dialogTitle == 'APECORRDATI'">MODIFICA STATO CORREZIONE DATI</span>
</h1>
<div mat-dialog-content [formGroup]="form">
    <div class="flex-row">
        <b>Inserire una data di chiusura prevista</b>
    </div>
    <br>
    <div class="flex-row">
        <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
            <mat-label class="big">Data chiusura dati *</mat-label>
            <input matInput [formControlName]="'dataChiusuraDati'" [matDatepicker]="picker1">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="flex-row">
        <mat-error *ngIf="this.form.controls.dataChiusuraDati.errors && this.form.controls.dataChiusuraDati.touched">
            <mat-error *ngIf="this.form.controls.dataChiusuraDati.errors.required">Campo obbligatorio
            </mat-error>
        </mat-error>
    </div>
</div>
<hr>
<mat-dialog-actions align="end">
    <button mat-stroked-button color='accent' class='persBtn' mat-dialog-close>
        <p class='cont'>ANNULLA</p>
    </button>
    <button mat-raised-button color='accent' class='persBtn' (click)="modificaStatoCompilazione()">
        <p class='cont'>MODIFICA</p>
    </button>
</mat-dialog-actions>